import { UserProvider } from './hooks/UserContext';
import { ProjectProvider } from './hooks/ProjectContext';
// routes
import Router from './routes';
// theme
import ThemeProvider from './theme';
// components
import ScrollToTop from './components/scroll-to-top';
import { StyledChart } from './components/chart';

// ----------------------------------------------------------------------

export default function App() {
  return (
    <UserProvider>
    <ProjectProvider>
    <ThemeProvider>
      <ScrollToTop />
      <StyledChart />
      <Router />
    </ThemeProvider>
    </ProjectProvider>
    </UserProvider>
  );
}
